import { render, staticRenderFns } from "./ru.vue?vue&type=template&id=32e02e9f&scoped=true&lang=html&"
import script from "./ru.vue?vue&type=script&lang=js&"
export * from "./ru.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e02e9f",
  null
  
)

export default component.exports